export enum OverlayFontEnum {
  Arial = 0,
  Tahoma = 1,
  TimesNewRoman = 2,
  Verdana = 3,
}

export type OverlayFont =
  | OverlayFontEnum.Arial
  | OverlayFontEnum.Tahoma
  | OverlayFontEnum.TimesNewRoman
  | OverlayFontEnum.Verdana;
